import styled from "styled-components/macro";

import FnrDateInput2 from "UI/FnrDateInput2";

import ExtendedFieldErrorMessage from "./ExtendedFieldErrorMessage";
import getIconName from "./getIconName";
import { Label, RequiredIcon } from "./styles";

/**
 * TODO: FnrDateInput does not accept a value or default value prop
 * so we need to create a new date component or update it to accept a value prop
 */

export default function DateField({
  value,
  onChange,
  field,
  error,
  accentColor,
}) {
  const { ID, icon, includeYear, title, inputIsRequired } = field;

  return (
    <div>
      <Label>
        {title}
        {inputIsRequired && <RequiredIcon />}
      </Label>

      <Wrapper>
        {icon && <Icon className={getIconName(icon)} color={accentColor} />}
        <FnrDateInput2
          initialDate={value}
          setDate={onChange}
          style={{
            border: "none",
            background: "none",
            fontSize: "18px",
            fontWeight: 400,
            color: "#222",
          }}
          focusColor={accentColor}
          killHoverStyles={true}
          includeYear={includeYear}
        />
        <Icon
          className="far fa-calendar"
          color={accentColor}
          style={{ marginLeft: "auto" }}
        />
      </Wrapper>

      {error ? (
        <ExtendedFieldErrorMessage className="fam_reg_error_msg">
          {error}
        </ExtendedFieldErrorMessage>
      ) : null}
    </div>
  );
}

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  /* gap: 4px; */
  background: white;
  border-radius: 9px;
  border: 1px solid #e0e0e0;
  padding: 0 12px;
`;

const Icon = styled.i`
  color: ${(props) => props.color};
  font-size: 18px;
`;
